import React from "react";

import { SvgIconProps, SvgIcon } from "@mui/material";

import { colors } from "@/theme/overrides/colors";

const DurationIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon viewBox="0 0 17 17" {...props}>
      <path
        d="M8.33333 16.6667C3.73083 16.6667 0 12.9358 0 8.33333C0 3.73083 3.73083 0 8.33333 0C12.9358 0 16.6667 3.73083 16.6667 8.33333C16.6667 12.9358 12.9358 16.6667 8.33333 16.6667ZM9.16667 8.33333V4.16667H7.5V10H12.5V8.33333H9.16667Z"
        fill={colors.gray}
      />
    </SvgIcon>
  );
};

export default DurationIcon;
